// Import react
import * as React from 'react';
import * as ReactDOM from 'react-dom';
// Import app-setup.
import '../app-setup';
// Import App component.
import App from './Components/App';
// Import material ui modules.
import { ThemeProvider } from '@mui/material';
import { StyledEngineProvider } from '@mui/material/styles';
// Import app theme.
import AppTheme from '@app/assets/app-theme';

ReactDOM.render(
	<StyledEngineProvider injectFirst>
		<ThemeProvider theme={AppTheme}>
			<App />
		</ThemeProvider>
	</StyledEngineProvider>,
	document.getElementById('root'));
